import { useState } from "react";
import "./langSelect.css";
import { retract } from "../../utilities/functions";

const LangSelect = ({
  menuClickImp,
  linkClickImp,
  languages,
  languageSelect,
}) => {
  const [menuTitle, setMenuTitle] = useState("eng");

  // Triggered on menu icon click
  const menuClick = (evt) => {
    const container = evt.target.closest(".lang-container");
    if (menuClickImp) menuClickImp(container, ".lang-menu");
  };
  // Triggered on list item click
  const linkClick = (evt, menuTitle) => {
    const container = evt.target.closest(".lang-container");

    if (linkClickImp) linkClickImp(container, ".lang-menu");
    setMenuTitle(menuTitle);

    retract(container, ".lang-menu", 300);
  };

  return (
    <div className="lang-container">
      <div className="lang-title" onClick={menuClick}>
        {menuTitle}
      </div>
      <ul className="lang-menu display-none">
        {languages.map((element, index) => (
          <li
            key={`{${element.name}${index}}`}
            onClick={(evt) => {
              linkClick(evt, element.short);
              languageSelect(element.short);
            }}
          >
            {element.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LangSelect;
